import React from 'react';
import HPContactEmail from './HPContactEmail';

const View = () => <HPContactEmail />;

export default View;
